const taskTemplates = require('../../task-templates');

const tasksData = [
	/* case 1 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		taskId: 'economy-skat-1',
		title: 'Opgave 1A',
		text: `Hvilke af disse tror i at virksomheder skal oplyse til SKAT?`,
		hintText: `Det, der skal oplyses, er <b>tal der har betydning for skat og afgifter</b> - ikke interne drifts- eller marketingdata.`,
		popupText: `På HHX arbejder man med økonomiske oplysninger og myndigheder.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'inform', 
				title: `Skal oplyses`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'not-inform', 
				title: `Skal ikke oplyses`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Moms`,
				categoryIds: ['inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Omsætning`,
				categoryIds: ['inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Privatforbrug`,
				categoryIds: ['inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Rabat fra leverandører`,
				categoryIds: ['inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Antal besøgende kunder på hjemmesiden`,
				categoryIds: ['not-inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, 
				text: `Lager-adresse`,
				categoryIds: ['not-inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, 
				text: `Antal kunder`,
				categoryIds: ['not-inform']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, 
				text: `Antal betalte fakturaer`,
				categoryIds: ['not-inform']
			}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		taskId: 'economy-skat-2',
		lockedById: 'economy-skat-1',
		title: 'Opgave 1B',
		text: `<b>Følgende oplysninger skal gives til skat - men hvad er vigtigst?</b>
			<br /><br />Sæt i korrekt rækkefølge.`,
		hintText: `Det vigtigste er det, der <b>identificerer virksomheden og har betydning for skat og betaling</b> - ikke interne beskrivelser eller personoplysninger.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `CVR nummer`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, 
				text: `Virksomhedsform`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, 
				text: `Omsætning`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, 
				text: `Ledelsesberetning`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, 
				text: `Ansattes navne`,
				correctOrderNumbers: [5]
			})
		]
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'economy-important-numbers-1a',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>afkastningsgraden</b>.
		<br /><br />Skriv svaret med to decimaler.`,
		answer: 1231.25,
		unit: '',
		hintText: `(Resultat før renter ÷ gennemsnitlige aktiver) x 100.`,
		popupText: `<b>Afkastningsgraden</b>
			<br /><br />Bruges i virkeligheden til at se, hvor god en virksomhed er til at tjene penge på det, den ejer.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'economy-important-numbers-1b',
		lockedById: 'economy-important-numbers-1a',
		text: `Kig på nøgletallene. 
		<br /><br />Brug dem til at udregne <b>overskudsgraden</b>.
		<br /><br />Skriv svaret med to decimaler.`,
		answer: 103.89,
		unit: '',
		hintText: `(Resultat af primær drift ÷ omsætning) x 100.`,
		popupText: `<b>Overskudsgraden</b>
			<br /><br />Bruges i virkeligheden til at se, hvor meget virksomheden tjener på sit salg.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 1C',
		taskId: 'economy-important-numbers-1c',
		lockedById: 'economy-important-numbers-1b',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne aktivernes <b>omsætningshastighed</b>.
			<br /><br />Skriv svaret med to decimaler.`,
		answer: 20.35,
		unit: '',
		hintText: `Nettoomsætning ÷ gennemsnitlige aktiver.`,
		popupText: `<b>Omsætningshastighed</b>
			<br /><br />Bruges i virkeligheden til at se, hvor effektivt virksomheden bruger sine ting og sit lager.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		title: 'Opgave 1D',
		taskId: 'economy-important-numbers-1d',
		lockedById: 'economy-important-numbers-1c',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>gældsrenten</b>.
			<br /><br />Skriv svaret med to decimaler.`,
		answer: 59.22,
		unit: '',
		hintText: `(Finansielle omkostninger x 100) ÷ gennemsnitlige gældsforpligtelser.`,
		popupText: `<b>Gældsrenten</b>
			<br /><br />Bruges i virkeligheden til at finde ud af, hvor dyr virksomhedens gæld er.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		title: 'Opgave 1E',
		taskId: 'economy-important-numbers-1e',
		lockedById: 'economy-important-numbers-1d',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>egenkapitalens forrentning</b>.
			<br /><br />Skriv svaret med to decimaler.`,
		answer: 4652.78,
		unit: '',
		hintText: `(Resultat før skat x 100) ÷ gennemsnitlig egenkapital.`,
		popupText: `<b>Egenkapitalens forrentning</b>
			<br /><br />Bruges i virkeligheden til at se, om ejernes penge giver et godt afkast.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 6,
		title: 'Opgave 1F',
		taskId: 'economy-important-numbers-1f',
		lockedById: 'economy-important-numbers-1e',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>dækningsgraden</b>.
			<br /><br />Skriv svaret med to decimaler.`,
		answer: 6.32,
		unit: '',
		hintText: `(Dækningsbidrag × 100) ÷ nettoomsætning.`,
		popupText: `<b>Dækningsgraden</b>
			<br /><br />Bruges i virkeligheden til at se, hvor mange penge der er tilbage, når en vare er solgt.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 7,
		title: 'Opgave 1G',
		taskId: 'economy-important-numbers-1g',
		lockedById: 'economy-important-numbers-1f',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>gennemsnitslager</b>.`,
		answer: 1200000,
		unit: '',
		hintText: `Gennemsnitslager i kr. = gennemsnitslager i enheder × kostpris.`,
		popupText: `<b>Gennemsnitslager</b>
			<br /><br />Bruges i virkeligheden til at se, hvor mange penge der er bundet i lager.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 8,
		title: 'Opgave 1H',
		taskId: 'economy-important-numbers-1h',
		lockedById: 'economy-important-numbers-1g',
		text: `Kig på nøgletallene. 
			<br /><br />Brug dem til at udregne <b>lagerservicegraden</b>.
			<br /><br />Skriv svaret med to decimaler.`,
		answer: 61.35,
		unit: '',
		hintText: `(Leveret antal enheder × 100) ÷ bestilte antal enheder.`,
		popupText: `<b>Lagerservicegraden</b>
			<br /><br />Bruges i virkeligheden til at se, hvor god virksomheden er til at levere til tiden.`,
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 9,
		taskId: 'economy-important-numbers-2',
		title: 'Opgave 2',
		text: `En medarbejder i indkøb mangler overblik.
			<br /><br />Hjælp <b>Future Business A/S</b> med at beregne indextal ved at sætte formlen i den rigtige rækkefølge.`,
		hintText: 'Tag tallet for året, gang med 100 og divider med basisåret til sidst.',
		files: [
			{
				id: 'economy-numbers',
				type: 'image',
				btnText: 'Se nøgletal',
			}		
		],
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Årstal`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, 
				text: `Gange`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, 
				text: `100`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, 
				text: `Divideret med`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, 
				text: `Basisårets tal`,
				correctOrderNumbers: [5]
			})
		]
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'economy-purchases-1',
		title: 'Opgave 1',
		text: `<b>Hvad er vigtigst</b> at have i en nyåbnet Future Business A/S butik? 
			<br /><br />Sæt tingene i rækkefølge fra mest til mindst vigtig. `,
		hintText: `Det vigtigste er det, der får hverdagen til at fungere fra dag ét - før komfort og ekstra faciliteter.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Arbejdspladser og inventar`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, 
				text: `Computere til medarbejdere`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, 
				text: `Mødelokale til kunder`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, 
				text: `Stabil internetforbindelse`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, 
				text: `Snacks`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'economy-purchases-2',
		layout: 'economy-shopper-items',
		avatarId: 'avatar-3',
		text: `<b>Hvilke 4 ting benytter en ansat blandt andet på et kontor?</b>
			<br /><br />Vælg de vigtigste ting. Tryk OK, når I mener, I har dem alle.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'laptop', title: 'Computer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'phone', title: 'Telefon', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'note-book', title: 'Notesblok', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'office-chair', title: 'Kontorstol', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'apron', title: 'Forklæde'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'sunglasses', title: 'Briller'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'shirt-purple', title: 'Trøje'
			})
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1A',
	// 	taskId: 'economy-multiple-choice-buyer-tasks',
	// 	text: `Hvilke opgaver har vores medarbejdere i indkøbsafdelingen?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, text: 'Indkøber virksomhedens produkter uden yderligere ansvar'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, text: 'Indkøber virksomhedens produkter markedsfører dem på nettet på det rigtige tidspunkter'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, text: 'Indkøber de rigtige produkter, i den rette mængde, til den rigtige tid og til den rigtige pris', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4, text: 'Indkøber og sælger produkter over nettet'
	// 		})
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'economy-international-1a',
		text: `<b>Future Business A/S overvejer at sælge løsninger til kunder i andre lande</b>.
			<br /><br />Hvad kaldes det, når man sælger til udlandet?`,
		hintText: `Når en virksomhed sælger noget ud af landet, kaldes det <b>ikke</b> import.`,
		popupText: `På HHX arbejder man med handel på tværs af landegrænser.`,
		image: 'hhx-economy-international-1a',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Eksport', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Import'				
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Distribution'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Outsourcing'
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'economy-international-1b',
		lockedById: 'economy-international-1a',
		text: `Hvis virksomheden i stedet køber ydelser fra virksomheder i udlandet, hvad kaldes det så?`,
		hintText: `Køb fra udlandet = modsætningen til eksport.`,
		popupText: `På HHX arbejder man med grundbegreber i international handel.`,
		image: 'hhx-economy-international-1b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Import', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Omvendt eksport'				
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Insourcing'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Distribution'
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 3,
		title: 'Opgave 2',
		taskId: 'economy-international-2',
		text: `<b>Når vi vælger at handle med kunder i flere EU-lande.</b>
			<br /><br />Hvilken valuta vil I oftest modtage?`,
		hintText: `De fleste lande i EU bruger den samme fælles valuta.`,
		image: 'hhx-economy-international-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Danske kroner'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Dollars'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Euro', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Pund'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Krypto Valuta'
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'economy-international-3',
		text: `<b>Future Business A/S arbejder internationalt</b>.
			<br /><br />Sorter landene i <b>EU-lande</b> og <b>ikke-EU-lande</b>.`,
		hintText: `EU-lande er europæiske lande, der er med i EU-samarbejdet. Lande uden for Europa eller som har valgt at stå udenfor, hører ikke til i EU.`,
		popupText: `På HHX arbejder man med EU, handel og samarbejde mellem lande.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'eu', 
				title: `EU-lande`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'not-eu', 
				title: `Ikke-EU-lande`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'denmark', 
				text: `Danmark`,
				categoryIds: ['eu']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'germany', 
				text: `Tyskland`,
				categoryIds: ['eu']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'france', 
				text: `Frankrig`,
				categoryIds: ['eu']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'usa', 
				text: `USA`,
				categoryIds: ['not-eu']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'china', 
				text: `Kina`,
				categoryIds: ['not-eu']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'norway', 
				text: `Norge`,
				categoryIds: ['not-eu']
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 5,
		title: 'Opgave 4',
		taskId: 'economy-international-4',
		text: `International handel giver både muligheder og udfordringer.
			<br /><br /><b>Sorter disse ting i fordele og ulemper</b>.`,
		hintText: `Tænk på, hvad der giver virksomheden flere muligheder og vækst – og hvad der gør arbejdet mere komplekst eller risikabelt.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'pros', 
				title: `Fordele`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'cons', 
				title: `Ulemper`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'more-customers', 
				text: `Flere kunder`,
				categoryIds: ['pros']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'bigger-market', 
				text: `Større marked`,
				categoryIds: ['pros']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'growth-potential', 
				text: `Mulighed for vækst`, 
				categoryIds: ['pros']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'longer-delivery-time', 
				text: `Længere leveringstid`,
				categoryIds: ['cons']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'currency-risks', 
				text: `Valutarisiko`,
				categoryIds: ['cons']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'different-rules', 
				text: `Forskellige regler`,
				categoryIds: ['cons']
			}),
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 6,
		title: 'Opgave 5',
		taskId: 'economy-international-5',
		text: `<b>Når I for Future Business A/S handler med lande uden for EU.</b>
			<br /><br />Hvad kaldes så den ekstra afgift, der kan komme på handel med udlandet?`,
		answer: 'told',
		unit: null,
		subtype: 'string',
		hintText: `Det er den afgift, der kan komme, når varer krydser grænsen ind i et land uden for EU. 
			<br /><br /><b>Det kan være en god ide at google hvad navnet er</b>.`,
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 7,
		taskId: 'economy-international-6',
		title: 'Opgave 6',
		text: `<b>Hvis ledelsen vil ind på et nyt land - hvad er rækkefølgen så for de trin virksomheden skal igennem?</b>
			<br /><br />Sorter trinnene i den rigtige rækkefølge.`,
		hintText: `<b>Før I kan sælge noget i et nyt land, skal I forstå markedet og reglerne</b>. 
			<br /><br />Først derefter giver det mening at tilpasse løsningen, finde hjælp lokalt og starte salget.`,
		popupText: `På HHX arbejder man med, hvordan virksomheder planlægger og går ind på nye markeder.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Undersøg markedet`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, 
				text: `Undersøg landets lovgivninger`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, 
				text: `Tilpas løsningen`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, 
				text: `Find samarbejdspartner`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, 
				text: `Start salget`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 8,
		title: 'Opgave 7A',
		taskId: 'economy-international-7a',
		text: `<b>Future Business A/S følger med i, hvordan økonomien udvikler sig</b>.
			<br /><br />Hvis mange mennesker har arbejde og køber mere, hvad er der så det korrekte økonomiske udtryk for hvad der sker?`,
		hintText: `Det er nemt at google.`,
		image: 'hhx-economy-international-7a',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Højkonjunktur', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Lavkonjunktur'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Spiralkonjunktur'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Topkonjunktur'
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 9,
		title: 'Opgave 7B',
		taskId: 'economy-international-7b',
		lockedById: 'economy-international-7a',
		text: `Økonomien kan dog både gå op og ned. 
			<br /><br />Sorter disse ting i <b>økonomien går godt</b> eller <b>økonomien går skidt</b>.`,
		hintText: `Når flere har job, forbruget stiger og der investeres mere, går økonomien godt. Når job forsvinder, forbruget falder og investeringer bremses, går det skidt.`,
		popupText: `På HHX arbejder man med at forstå, hvordan disse ting påvirker virksomheder og forbrug.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'good', 
				title: `Økonomien går godt`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'bad', 
				title: `Økonomien går skidt`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'many-jobs', 
				text: `Mange har job`,
				categoryIds: ['good']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'high-consumption', 
				text: `Kunder bruger flere penge`,
				categoryIds: ['good']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'new-companies', 
				text: `Flere starter nye virksomheder`,
				categoryIds: ['good']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'few-jobs', 
				text: `Flere mister deres job`,
				categoryIds: ['bad']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'low-investments',
				text: `Færre laver investeringer`,
				categoryIds: ['bad']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 'low-consumption',
				text: `Kunder køber mindre`,
				categoryIds: ['bad']
			})
		]
	})
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'hhxedu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};